import { captureException } from '@sentry/react';
import { useQuery } from '@tanstack/react-query';
import { Topology } from 'topojson-specification';

async function fetchGeography(signal: AbortSignal) {
	try {
		const response = await fetch(`/data/us/counties.json`, { signal });
		const data = await response.json();
		return data as Topology;
	} catch (error) {
		console.error(error);
		captureException(error);
		throw error;
	}
}

export function useCountiesGeography() {
	const { data, isLoading, error } = useQuery({
		queryKey: ['counties'],
		queryFn: async ({ signal }) => fetchGeography(signal),
	});

	return {
		countiesGeography: data,
		countiesGeographyLoading: isLoading,
		countiesGeographyError: error,
	};
}
